import store from "../store";

export default function authGuard(to, from, next) {
  store.dispatch("verifyAuth").then(() => {
    if (to.path === "/" && store.state.auth) {
      next("/locations");
    } else {
      next();
    }
  });
}
